import React from 'react';
import PropTypes from 'prop-types';

import './button-group.scss';

const ButtonGroup = props => (
  <div {...props} className={`${ButtonGroup.baseClass} ${props.className}`} />
);

ButtonGroup.baseClass = 'tk-button-group';

ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

ButtonGroup.defaultProps = {
  className: '',
};

export default ButtonGroup;
